import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

interface BadgeProps {
  children: ReactNode;
  className?: string;
}

// One pill for the tool's status / diff / count tags; color via className.
export function Badge({ children, className }: BadgeProps): JSX.Element {
  return <span className={filterClasses("body-xs inline-flex items-center rounded-full px-2 py-0.5 font-semibold", className)}>{children}</span>;
}
